<div class="flex flex-column justify-content-center align-items-center relative overflow-hidden bg-login">
  <p-card class="login-card text-center border-round-xl card-body-nopadding transparent-effect">
    <ng-template pTemplate="header">
      @if (screenHeight < 400) {
        <div>&nbsp;</div>
      } @else {
        <img alt="Logo" [src]="headerImgSrc" class="login-logo">
      }
    </ng-template>
    <div class="tabs">
      <!-- titolo della sezione corrente (Accedi / Registrati) al posto dei vecchi tab -->
      <div class="login-title mx-2 pt-3 pb-2 mb-3 font-bold text-primary">{{ (activeTab === 'login' ? 'login' : 'signUp')|translate }}</div>
      @if (activeTab === 'login') {
        <!-- animate.enter: il pannello entra scivolando dal lato da cui "arriva" (login da sinistra, registrati da destra) -->
        <div class="tab-content" animate.enter="slide-in-left">
          @if (!logginIn) {
            <svg id="login_icon" data-name="Capa 1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 386.2 425.2"
                 width="120px" height="120px" class="cursor-pointer"
                 (click)="loginAzure()">
              <defs>
                <linearGradient id="sfumatura_rosso" x1="18.67" y1="212.6" x2="367.53" y2="212.6" gradientUnits="userSpaceOnUse">
                  <stop offset="0" stop-color="#c25d63"/>
                  <stop offset="0.36" stop-color="#831811"/>
                  <stop offset="0.68" stop-color="#c25d63"/>
                  <stop offset="1" stop-color="#831811"/>
                </linearGradient>
                <linearGradient id="sfumatura_blu" x1="18.67" y1="212.6" x2="367.53" y2="212.6" gradientUnits="userSpaceOnUse">
                  <stop offset="0" stop-color="#a4c7d2"/>
                  <stop offset="0.36" stop-color="#1b86a4"/>
                  <stop offset="0.68" stop-color="#a4c7d2"/>
                  <stop offset="1" stop-color="#1b86a4"/>
                </linearGradient>
              </defs>
              <circle class="cls-1" fill="url(#sfumatura_rosso)" cx="193.1" cy="212.6" r="174.43"/>
              <circle class="cls-2" fill="#5e1104" cx="193.1" cy="211.01" r="147.66"/>
              <circle class="cls-3" fill="#831811" cx="193.1" cy="212.6" r="139.05"/>
              <path fill="#fff"
                    d="M245.08,169.2V140a52,52,0,1,0-104,0V169.2a11.66,11.66,0,0,0-10.58,11.61v82.72a11.66,11.66,0,0,0,11.67,11.66H244a11.67,11.67,0,0,0,11.67-11.66V180.81A11.66,11.66,0,0,0,245.08,169.2Zm-35.27,95.6c-2.33-.7-19-25.94-27.14-38.38C184.38,246,186,265,186,265s1,1.2-2.54,1.76-4-1.38-4-1.38-5.86-66.89-6.73-69-2.06-13.4-2.06-13.4a28.25,28.25,0,0,1,6.38-1.22c2.24,0,1.21-1.16,1.84,3,.25,1.72,1.49,15.49,2.87,31.14,7.65,9.63,34.4,43.35,37,47.43C221.88,268.09,212.89,265.74,209.81,264.8Zm-25.43-53.06a4.3,4.3,0,1,1,3.09,5.24A4.31,4.31,0,0,1,184.38,211.74Zm20.69-5.56a6.17,6.17,0,1,1-4.44-7.52A6.18,6.18,0,0,1,205.07,206.18ZM201.18,189a8.72,8.72,0,1,1,6.25,10.62A8.71,8.71,0,0,1,201.18,189Zm28.09-19.83H156.93V141.23a36.17,36.17,0,1,1,72.34,0Z"/>
              <text fill="#fff" font-size="39.49" font-family="CenturyGothic, Century Gothic" transform="translate(130.53 327.25)">LOGIN</text>
              <path fill="#fff" opacity="0.13" d="M308.4,81.7A174.44,174.44,0,1,0,83.07,348C210.32,252.54,275.48,152.59,308.4,81.7Z"/>
            </svg>
          } @else {
            <p-progressSpinner strokeWidth="3" class="login-spinner inline-flex align-items-center justify-content-center"></p-progressSpinner>
          }
        </div>
      }
      @if (!isProduction) {
        @if (activeTab === 'register') {
          <div class="tab-content" animate.enter="slide-in-right">
            <div class="px-3">
              <form-input-text [label]="'email'|translate"
                               [control]="signUpFC"
                               [autofocus]="autofocusEmail" [addPadding]="true"
                               [errorMsg]="signUpFC.hasError('pattern') ? ('err_email_pattern'|translate) : null">
              </form-input-text>
              <div class="flex justify-content-center mb-2">
                <re-captcha #captchaRef [formControl]="captchaFC" [siteKey]="captchaSiteKey"></re-captcha>
              </div>
              <button pButton icon="mdi mdi-account-check" [label]="'signUp'|translate"
                      [disabled]="signUpFC.invalid || sendingInvite || captchaFC.invalid"
                      [loading]="sendingInvite" loadingIcon="mdi mdi-loading mdi-spin-fast"
                      (click)="register()">
              </button>
            </div>
          </div>
        }
        <div class="flex px-3 pb-2" [class.justify-content-end]="activeTab === 'login'" [class.justify-content-start]="activeTab === 'register'">
          <button type="button" class="switch-pannello-btn inline-flex align-items-center gap-1 py-1 px-2 border-none cursor-pointer font-semibold" (click)="togglePannello()">
            @if (activeTab === 'login') {
              <span>{{ 'signUp'|translate }}</span>
              <i class="mdi mdi-arrow-right"></i>
            } @else {
              <i class="mdi mdi-arrow-left"></i>
              <span>{{ 'login'|translate }}</span>
            }
          </button>
        </div>
      }
    </div>
    <div class="px-2">
      <p-divider class="my-0"/>
    </div>
    <ng-template pTemplate="footer">
      <div class="flex flex-column gap-1 border-round-bottom-xl py-2 px-3 footer-styles">
        <!-- Riga identità: nome + P.IVA a sinistra, versione a destra -->
        <div class="flex align-items-center justify-content-between gap-2 flex-wrap">
          <span class="flex align-items-center gap-2">
            <span class="text-sm font-bold">Kleros s.r.l.</span>
            <span class="opacity-50">•</span>
            <span>{{ 'partitaIvaShort'|translate }} 01752100931</span>
          </span>
          <!--<span class="text-xxs font-italic">{{ 'v. ' + appVersion }}</span>-->
        </div>
        <div class="flex align-items-center gap-1 footer-contacts">
          <i class="mdi mdi-map-marker"></i>
          <span>Foro Buonaparte 22 - 20121 Milano</span>
        </div>
        <div class="flex align-items-center flex-wrap gap-3 footer-contacts">
          <span class="flex align-items-center gap-1">
            <i class="mdi mdi-phone-outline" [pTooltip]="'nrVerde'|translate" tooltipPosition="top"></i>
            <span>800.33.02.33</span>
          </span>
          <a href="mailto:info@kleros.it" class="flex align-items-center gap-1 no-underline footer-link">
            <i class="mdi mdi-email-outline"></i>
            <span>info@kleros.it</span>
          </a>
          <a href="http://www.kleros.eu" target="_blank" rel="noopener" class="flex align-items-center gap-1 no-underline footer-link">
            <i class="mdi mdi-web"></i>
            <span>www.kleros.eu</span>
          </a>
        </div>
      </div>
    </ng-template>
  </p-card>
</div>
